import { ReactNode } from 'react';
import { GeoBlocking } from './components/GeoBlocking';
import { useGetAccessInfoQuery } from 'modules/common/actions/getAccessInfo';

interface IGeoBlockingGuardProps {
  children?: ReactNode;
  countryCodes?: string[];
  asPage?: boolean;
}

export function GeoBlockingGuard({
  children,
  countryCodes,
  asPage = false,
}: IGeoBlockingGuardProps): JSX.Element {
  const { data, isLoading } = useGetAccessInfoQuery(countryCodes);

  if (!data?.isAccessAllowed && !isLoading) {
    return <GeoBlocking asPage={asPage} />;
  }

  return <>{children}</>;
}
